import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IDropdown, IAmenity } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVTextArea } from "../../shared/JVTextarea";

const schema = yup.object({
    name: yup.string().required("Amenity Name is required"),
    amenityType: yup.string().required("Amenity Type is required")
});

interface Iprops {
    singleData: IAmenity,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IAmenity>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: IAmenity) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`Amenity${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit Amenity" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Amenity Name" control={control} name="name" error={errors.name?.message} />
                <JVDropdown required control={control} label="Amenity Type" options={[
                    { id: 'Hotel', name: 'Hotel' },
                    { id: 'Room', name: 'Room' },
                    { id: 'Both', name: 'Both' }
                ]} optionLabel="name" optionValue="id" name="amenityType" error={errors.amenityType?.message} />
                <JVTextArea column={1} label="Description" control={control} name="description" error={errors.description?.message} />
                {props.singleData.id && <JVCheckbox label="Status" control={control} name="isActive" />}

                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}